export const Constants = {
    'STATUS_REJECTED': -1,
    'STATUS_APPLIED': 0,
    'STATUS_READ': 100,
    // 'STATUS_SCREENING': 200, // Verificacion de información
    // 'STATUS_INTERVIEW': 250,
    // 'STATUS_TEST': 265,
    'STATUS_PRESELECTED': 275,
    'STATUS_SELECTED': 300,

    'STATUS_PENDING': 0,
    'STATUS_NOT_INTERESTED': -1,
    'STATUS_VISITED': -2,
    'STATUS_INTERESTED': 1,
    'STATUS_POSTULED': 2,
    'STATUS_FORM_COMPLETED': 3,
    'STATUS_DELETED': -6
};



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/constants.ts